import React from 'react';
import { Switch, useRouteMatch } from 'react-router-dom';
import PrivateRoute from '../../components/shared/PrivateRoute';
import DashboardLayout from '../../layouts/DashoardLayout';
import { Box, Paper } from '../../ui/core';
import { flushPageSx, surfaceCardSx } from '../../ui/styles';

import StationsTable from './StationsTable';
import StationBuilder from './StationBuilder';

// StationsSearch isn't rendered here anymore — StationsTable owns its own
// header row (title + city filter + add-station), matching the pattern used
// by the other table pages, so it stays inside the shared card.
const StationsShell = () => {
  // `/stations/map` is kept EXACTLY as the path even though the component behind
  // it is now the station builder. This match is what adds `overflow: 'hidden'`
  // to the surrounding card, and the map needs that clamp or it blows out of the
  // card; renaming the route silently loses it. It is also the URL already in
  // people's history and bookmarks.
  const isMapRoute = !!useRouteMatch({ path: '/stations/map' });

  return (
    <Box sx={flushPageSx}>
      <Paper
        elevation={0}
        sx={{ ...surfaceCardSx, flex: 1, minWidth: 0, ...(isMapRoute && { overflow: 'hidden' }) }}
      >
        <Switch>
          <PrivateRoute exact path="/stations" component={StationsTable} />
          <PrivateRoute path="/stations/map" component={StationBuilder} />
        </Switch>
      </Paper>
    </Box>
  );
};

const Stations = () => (
  <DashboardLayout flush title="Stations">
    <StationsShell />
  </DashboardLayout>
);

export default Stations;
